(function () {
  function cleanText(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeText(text) {
    return cleanText(text)
      .toLocaleLowerCase()
      .replace(/\s*\*+\s*$/, '')
      .replace(/:\s*$/, '');
  }

  function getCurrentLanguage() {
    const htmlLanguage = document.documentElement.getAttribute('lang');
    const shopifyLanguage =
      window.Shopify && typeof window.Shopify.locale === 'string'
        ? window.Shopify.locale
        : '';

    const language = cleanText(htmlLanguage || shopifyLanguage || 'de').toLowerCase();

    return language.startsWith('en') ? 'en' : 'de';
  }

  const CURRENT_LANGUAGE = getCurrentLanguage();

  const TRANSLATIONS = {
    de: {
      dogName: 'Hundename',
      gender: 'Geschlecht*',
      male: 'Männlich',
      female: 'Weiblich',
      profileTitle: 'Neues Hunde-Profil',
      addProfilePicture: 'Profilbild hinzufügen',
      profilePicture: 'Profilbild',
      uploadDogPicture: 'Bild deines Hundes hochladen',
      birthday: 'Geburtstag*',
      datePlaceholder: 'tt.mm.jjjj',
      adopted: 'Dies ist nur eine Schätzung – mein Hund ist adoptiert',
      breed: 'Rasse*',
      breedPlaceholder: 'Rasse auswählen',
      health: 'Gesundheitsprobleme*',
      activity: 'Aktivität und Bewegung*',
      bodyType: 'Statur*',
      weight: 'Gewicht*',
      weightPlaceholder: '0,01',
      height: 'Größe*',
      heightPlaceholder: 'Größe eingeben',
      cancel: 'Abbrechen',
      save: 'Speichern'
    },

    en: {
      dogName: 'Dog name',
      gender: 'Gender*',
      male: 'Male',
      female: 'Female',
      profileTitle: 'New dog profile',
      addProfilePicture: 'Add profile picture',
      profilePicture: 'Profile picture',
      uploadDogPicture: 'Upload a photo of your dog',
      birthday: 'Birthday*',
      datePlaceholder: 'dd/mm/yyyy',
      adopted: 'This is only an estimate – my dog is adopted',
      breed: 'Breed*',
      breedPlaceholder: 'Select breed',
      health: 'Health issues*',
      activity: 'Activity and exercise*',
      bodyType: 'Body type*',
      weight: 'Weight*',
      weightPlaceholder: '0.01',
      height: 'Height*',
      heightPlaceholder: 'Enter height',
      cancel: 'Cancel',
      save: 'Save'
    }
  };

  const FIELD_LABELS = {
    dogName: [
      'Hundename',
      'Hundename*',
      'Dog name',
      'Dog name*'
    ],

    gender: [
      'Geschlecht',
      'Geschlecht*',
      'Gender',
      'Gender*'
    ],

    profileTitle: [
      'Neues Hunde-Profil',
      'Neues Hunde Profil',
      'New dog profile',
      'New Dog Profile'
    ],

    upload: [
      'Profilbild hinzufügen',
      'Profilbild hinzufugen',
      'Add profile picture',
      'Upload profile picture'
    ],

    birthday: [
      'Datumsfeld',
      'Geburtstag',
      'Geburtstag*',
      'Date field',
      'Birthday',
      'Birthday*'
    ],

    adopted: [
      'Dies ist nur eine Schätzung – mein Hund ist adoptiert',
      'Dies ist nur eine Schatzung – mein Hund ist adoptiert',
      'This is only an estimate – my dog is adopted',
      'This is only an estimate - my dog is adopted'
    ],

    breed: [
      'Rasse',
      'Rasse*',
      'Breed',
      'Breed*'
    ],

    health: [
      'Gesundheitsprobleme',
      'Gesundheitsprobleme*',
      'Health issues',
      'Health issues*',
      'Health problems',
      'Health problems*'
    ],

    activity: [
      'Aktivität und Bewegung',
      'Aktivität und Bewegung*',
      'Aktivitat und Bewegung',
      'Aktivitat und Bewegung*',
      'Activity and exercise',
      'Activity and exercise*',
      'Activity and movement',
      'Activity and movement*'
    ],

    bodyType: [
      'Statur',
      'Statur*',
      'Body type',
      'Body type*',
      'Build',
      'Build*'
    ],

    weight: [
      'Gewicht',
      'Gewicht*',
      'Weight',
      'Weight*'
    ],

    height: [
      'Größe',
      'Größe*',
      'Grosse',
      'Grosse*',
      'Height',
      'Height*',
      'Size',
      'Size*'
    ]
  };

  const ACCOUNT_FIELD_LABELS = [
    ['First name', 'Vorname'],
    ['Last name', 'Nachname'],
    ['Email', 'E-Mail'],
    ['Phone', 'Telefon']
  ];

  const NONE_VALUES = [
    'Keines davon',
    'keins davon',
    'None of these',
    'None of the above'
  ];

  const PAWSAN_BREEDS = [
    'Mischling',
    'Andere Rasse / nicht gelistet',
    'Ich weiß es nicht genau',
    'Akita',
    'Alaskan Malamute',
    'American Staffordshire Terrier',
    'Australian Cattle Dog',
    'Australian Shepherd',
    'Basenji',
    'Basset Hound',
    'Beagle',
    'Bearded Collie',
    'Belgischer Schäferhund',
    'Berner Sennenhund',
    'Bichon Frisé',
    'Border Collie',
    'Border Terrier',
    'Boston Terrier',
    'Boxer',
    'Bull Terrier',
    'Bullmastiff',
    'Cane Corso',
    'Cavalier King Charles Spaniel',
    'Chihuahua',
    'Chow Chow',
    'Cocker Spaniel',
    'Collie',
    'Dackel',
    'Dalmatiner',
    'Deutsche Dogge',
    'Deutscher Boxer',
    'Deutscher Pinscher',
    'Deutscher Schäferhund',
    'Dobermann',
    'English Bulldog',
    'English Springer Spaniel',
    'Eurasier',
    'Flat Coated Retriever',
    'Französische Bulldogge',
    'Golden Retriever',
    'Havaneser',
    'Hovawart',
    'Jack Russell Terrier',
    'Labrador Retriever',
    'Lagotto Romagnolo',
    'Leonberger',
    'Magyar Vizsla',
    'Malteser',
    'Mops',
    'Münsterländer',
    'Neufundländer',
    'Papillon',
    'Parson Russell Terrier',
    'Pekingese',
    'Podenco',
    'Pomeranian / Zwergspitz',
    'Pudel',
    'Rhodesian Ridgeback',
    'Rottweiler',
    'Samojede',
    'Schnauzer',
    'Sheltie / Shetland Sheepdog',
    'Shiba Inu',
    'Shih Tzu',
    'Siberian Husky',
    'Staffordshire Bull Terrier',
    'Weimaraner',
    'Welsh Corgi',
    'West Highland White Terrier',
    'Whippet',
    'Yorkshire Terrier',
    'Zwergpinscher',
    'Zwergpudel',
    'Zwergschnauzer'
  ];

  const BREED_LABELS_EN = {
    Mischling: 'Mixed breed',
    'Andere Rasse / nicht gelistet': 'Other breed / not listed',
    'Ich weiß es nicht genau': "I'm not sure",
    'Belgischer Schäferhund': 'Belgian Shepherd',
    'Berner Sennenhund': 'Bernese Mountain Dog',
    Dackel: 'Dachshund',
    Dalmatiner: 'Dalmatian',
    'Deutsche Dogge': 'Great Dane',
    'Deutscher Boxer': 'Boxer',
    'Deutscher Pinscher': 'German Pinscher',
    'Deutscher Schäferhund': 'German Shepherd',
    'Französische Bulldogge': 'French Bulldog',
    Havaneser: 'Havanese',
    Malteser: 'Maltese',
    Mops: 'Pug',
    Neufundländer: 'Newfoundland',
    Pudel: 'Poodle',
    Samojede: 'Samoyed',
    'Pomeranian / Zwergspitz': 'Pomeranian / Miniature Spitz',
    Zwergpinscher: 'Miniature Pinscher',
    Zwergpudel: 'Miniature Poodle',
    Zwergschnauzer: 'Miniature Schnauzer'
  };

  function translate(key) {
    return (
      TRANSLATIONS[CURRENT_LANGUAGE][key] ||
      TRANSLATIONS.de[key] ||
      key
    );
  }

  function getBreedLabel(breed) {
    if (CURRENT_LANGUAGE === 'en') {
      return BREED_LABELS_EN[breed] || breed;
    }

    return breed;
  }

  function getGroupLabel(group) {
    const label = group.querySelector('.custlo-t1-form-label');

    return cleanText(
      label ? label.textContent : ''
    );
  }

  function matchesAnyLabel(actualLabel, expectedLabels) {
    const normalizedActual = normalizeText(actualLabel);

    const labels = Array.isArray(expectedLabels)
      ? expectedLabels
      : [expectedLabels];

    return labels.some(function (label) {
      return normalizedActual === normalizeText(label);
    });
  }

  function findGroupByLabel(form, labelTexts) {
    return Array.from(
      form.querySelectorAll('.custlo-t1-form-group')
    ).find(function (group) {
      return matchesAnyLabel(
        getGroupLabel(group),
        labelTexts
      );
    });
  }

  function findGroupByInputName(form, inputName) {
    return Array.from(
      form.querySelectorAll('.custlo-t1-form-group')
    ).find(function (group) {
      return Array.from(
        group.querySelectorAll('input, select, textarea')
      ).some(function (field) {
        return field.name === inputName;
      });
    });
  }

  function findGroupByInputValue(form, values) {
    const expectedValues = Array.isArray(values)
      ? values
      : [values];

    return Array.from(
      form.querySelectorAll('.custlo-t1-form-group')
    ).find(function (group) {
      return Array.from(
        group.querySelectorAll('input')
      ).some(function (input) {
        return expectedValues.some(function (value) {
          return (
            normalizeText(input.value) ===
            normalizeText(value)
          );
        });
      });
    });
  }

  function setGroupLabel(group, text) {
    if (!group) return;

    const label = group.querySelector(
      '.custlo-t1-form-label'
    );

    if (label) {
      label.textContent = text;
    }
  }

  function hasEssentialFields(form) {
    return Boolean(
      findGroupByLabel(
        form,
        FIELD_LABELS.profileTitle
      ) &&
      findGroupByLabel(
        form,
        FIELD_LABELS.breed
      ) &&
      findGroupByLabel(
        form,
        FIELD_LABELS.health
      ) &&
      findGroupByLabel(
        form,
        FIELD_LABELS.bodyType
      )
    );
  }

  function groupSafeHide(group) {
    if (!group) return;

    group.classList.add(
      'pawsan-hidden-field'
    );
  }

  function hideAccountFields(form) {
    ACCOUNT_FIELD_LABELS.forEach(
      function (labelAliases) {
        const group = findGroupByLabel(
          form,
          labelAliases
        );

        groupSafeHide(group);
      }
    );

    const newsletterGroup = findGroupByInputName(
      form,
      'accepts_marketing'
    );

    groupSafeHide(newsletterGroup);
  }

  function setupTitle(form) {
    const group = findGroupByLabel(
      form,
      FIELD_LABELS.profileTitle
    );

    if (!group) return;

    setGroupLabel(
      group,
      translate('profileTitle')
    );

    group.classList.remove(
      'custlo-t1-form-col-half'
    );

    group.classList.add(
      'custlo-t1-form-col-full',
      'pawsan-profile-title-group'
    );
  }

  function setupUpload(form) {
    const group = findGroupByLabel(
      form,
      FIELD_LABELS.upload
    );

    if (!group) return;

    setGroupLabel(
      group,
      translate('addProfilePicture')
    );

    group.classList.add(
      'pawsan-upload-group'
    );

    const uploadBox = group.querySelector(
      '.custlo-t1-file-upload'
    );

    if (!uploadBox) return;

    let helper = uploadBox.querySelector(
      '.pawsan-upload-helper'
    );

    if (!helper) {
      helper = document.createElement('div');

      helper.className =
        'pawsan-upload-helper';

      uploadBox.insertBefore(
        helper,
        uploadBox.firstChild
      );
    }

    helper.innerHTML =
      '<span class="pawsan-upload-icon">🐾</span>' +
      '<span><strong>' +
      translate('profilePicture') +
      '</strong><br>' +
      translate('uploadDogPicture') +
      '</span>';
  }

  function setupDogName(form) {
    const group = findGroupByLabel(
      form,
      FIELD_LABELS.dogName
    );

    if (!group) return;

    setGroupLabel(
      group,
      translate('dogName')
    );
  }

  function setupGenderGroup(form) {
    const group = findGroupByLabel(
      form,
      FIELD_LABELS.gender
    );

    if (!group) return;

    setGroupLabel(
      group,
      translate('gender')
    );

    group
      .querySelectorAll(
        '.custlo-t1-form-check'
      )
      .forEach(function (item) {
        const input = item.querySelector(
          'input[type="radio"], input[type="checkbox"]'
        );

        const optionLabel = item.querySelector(
          '.custlo-t1-form-check-label'
        );

        if (!input || !optionLabel) return;

        const inputValue = normalizeText(
          input.value || optionLabel.textContent
        );

        const labelValue = normalizeText(
          optionLabel.textContent
        );

        const isMale = [
          'männlich',
          'mannlich',
          'male',
          'm'
        ].some(function (value) {
          const normalizedValue =
            normalizeText(value);

          return (
            inputValue === normalizedValue ||
            labelValue === normalizedValue
          );
        });

        const isFemale = [
          'weiblich',
          'female',
          'f'
        ].some(function (value) {
          const normalizedValue =
            normalizeText(value);

          return (
            inputValue === normalizedValue ||
            labelValue === normalizedValue
          );
        });

        if (isMale) {
          optionLabel.textContent =
            translate('male');
        }

        if (isFemale) {
          optionLabel.textContent =
            translate('female');
        }
      });
  }

  function setupBirthday(form) {
    const group = findGroupByLabel(
      form,
      FIELD_LABELS.birthday
    );

    if (!group) return;

    setGroupLabel(
      group,
      translate('birthday')
    );

    const input = group.querySelector('input');

    if (input) {
      input.placeholder =
        translate('datePlaceholder');

      input.required = true;
    }
  }

  function setupAdoptedCheckbox(form) {
    const group =
      findGroupByLabel(
        form,
        FIELD_LABELS.adopted
      ) ||
      findGroupByInputValue(
        form,
        FIELD_LABELS.adopted
      );

    if (!group) return;

    const label = group.querySelector(
      '.custlo-t1-form-label'
    );

    const checkLabel = group.querySelector(
      '.custlo-t1-form-check-label'
    );

    if (label) {
      label.textContent = '';
    }

    if (checkLabel) {
      checkLabel.textContent =
        translate('adopted');
    }
  }

  function setupBreedDropdown(form) {
    const breedGroup = findGroupByLabel(
      form,
      FIELD_LABELS.breed
    );

    const alphabetGroup =
      findGroupByInputValue(
        form,
        'Akita'
      );

    if (!breedGroup) return;

    setGroupLabel(
      breedGroup,
      translate('breed')
    );

    let select = breedGroup.querySelector(
      '.pawsan-breed-select'
    );

    const originalInputs = [
      ...Array.from(
        breedGroup.querySelectorAll('input')
      ),

      ...(
        alphabetGroup
          ? Array.from(
              alphabetGroup.querySelectorAll(
                'input'
              )
            )
          : []
      )
    ];

    if (!select) {
      const firstOriginalInput =
        breedGroup.querySelector('input');

      const originalName =
        firstOriginalInput
          ? firstOriginalInput.name
          : 'rasse';

      breedGroup
        .querySelectorAll(
          '.custlo-t1-form-check-group'
        )
        .forEach(function (checkGroup) {
          checkGroup.classList.add(
            'pawsan-source-hidden'
          );
        });

      if (alphabetGroup) {
        alphabetGroup.classList.add(
          'pawsan-source-hidden'
        );
      }

      originalInputs.forEach(
        function (input) {
          input.required = false;
        }
      );

      select = document.createElement(
        'select'
      );

      select.className =
        'custlo-t1-form-input pawsan-breed-select';

      select.id =
        'pawsan-rasse-select';

      select.name =
        originalName;

      select.required = true;

      breedGroup.appendChild(select);

      select.addEventListener(
        'change',
        function () {
          originalInputs.forEach(
            function (input) {
              input.checked =
                input.value === select.value;
            }
          );

          select.classList.remove(
            'pawsan-field-error'
          );
        }
      );
    }

    const currentValue = select.value;

    select.innerHTML = '';

    const placeholder =
      document.createElement('option');

    placeholder.value = '';

    placeholder.textContent =
      translate('breedPlaceholder');

    placeholder.disabled = true;

    select.appendChild(placeholder);

    PAWSAN_BREEDS.forEach(
      function (breed) {
        const option =
          document.createElement('option');

        option.value = breed;

        option.textContent =
          getBreedLabel(breed);

        select.appendChild(option);
      }
    );

    const checkedInput =
      originalInputs.find(
        function (input) {
          return input.checked;
        }
      );

    if (currentValue) {
      select.value = currentValue;
    } else if (checkedInput) {
      select.value = checkedInput.value;
    } else {
      select.value = '';
      placeholder.selected = true;
    }
  }

  function setupUnitField(
    form,
    fieldKey,
    placeholderKey,
    unit
  ) {
    const group = findGroupByLabel(
      form,
      FIELD_LABELS[fieldKey]
    );

    if (!group) return;

    setGroupLabel(
      group,
      translate(fieldKey)
    );

    const input = group.querySelector('input');

    if (!input) return;

    input.placeholder =
      translate(placeholderKey);

    input.inputMode = 'decimal';

    input.required = true;

    let wrap = group.querySelector(
      '.pawsan-unit-wrap'
    );

    if (!wrap) {
      wrap = document.createElement('div');

      wrap.className =
        'pawsan-unit-wrap';

      input.parentNode.insertBefore(
        wrap,
        input
      );

      wrap.appendChild(input);
    }

    let unitElement = wrap.querySelector(
      '.pawsan-unit'
    );

    if (!unitElement) {
      unitElement =
        document.createElement('span');

      unitElement.className =
        'pawsan-unit';

      wrap.appendChild(unitElement);
    }

    unitElement.textContent = unit;
  }

  function setupHealthGroup(form) {
    const group = findGroupByLabel(
      form,
      FIELD_LABELS.health
    );

    if (!group) return;

    setGroupLabel(
      group,
      translate('health')
    );

    group.classList.add(
      'pawsan-health-group'
    );

    const inputs = Array.from(
      group.querySelectorAll(
        'input[type="checkbox"]'
      )
    );

    const noneInput = inputs.find(
      function (input) {
        return NONE_VALUES.some(
          function (value) {
            return (
              normalizeText(input.value) ===
              normalizeText(value)
            );
          }
        );
      }
    );

    if (!noneInput) return;

    if (
      group.dataset.pawsanHealthInitialized ===
      'true'
    ) {
      return;
    }

    group.dataset.pawsanHealthInitialized =
      'true';

    inputs.forEach(function (input) {
      input.addEventListener(
        'change',
        function () {
          if (
            input === noneInput &&
            input.checked
          ) {
            inputs.forEach(
              function (item) {
                if (item !== noneInput) {
                  item.checked = false;
                }
              }
            );
          }

          if (
            input !== noneInput &&
            input.checked
          ) {
            noneInput.checked = false;
          }

          refreshCheckedClass(group);
        }
      );
    });
  }

  function setupActivityGroup(form) {
    const group = findGroupByLabel(
      form,
      FIELD_LABELS.activity
    );

    if (!group) return;

    setGroupLabel(
      group,
      translate('activity')
    );

    group.classList.add(
      'pawsan-activity-group'
    );

    group
      .querySelectorAll(
        'input[type="radio"]'
      )
      .forEach(function (radio) {
        radio.required = true;
      });
  }

  function setupStaturGroup(form) {
    const group = findGroupByLabel(
      form,
      FIELD_LABELS.bodyType
    );

    if (!group) return;

    setGroupLabel(
      group,
      translate('bodyType')
    );

    group.classList.add(
      'pawsan-statur-group'
    );

    group
      .querySelectorAll('input')
      .forEach(function (input) {
        input.type = 'radio';
        input.required = true;
      });
  }

  function setupButtons(form) {
    const cancelButton =
      form.querySelector(
        '#custlo-t1-edit-cancel-btn'
      );

    const saveButton =
      form.querySelector(
        '#custlo-t1-edit-save-btn'
      );

    if (cancelButton) {
      cancelButton.textContent =
        translate('cancel');
    }

    if (saveButton) {
      saveButton.textContent =
        translate('save');
    }
  }

  function refreshCheckedClass(scope) {
    scope
      .querySelectorAll(
        '.custlo-t1-form-check'
      )
      .forEach(function (item) {
        const input = item.querySelector(
          '.custlo-t1-form-check-input'
        );

        if (!input) return;

        item.classList.toggle(
          'is-checked',
          input.checked
        );
      });
  }

  function setupCheckedClass(form) {
    refreshCheckedClass(form);

    if (
      form.dataset.pawsanCheckedInitialized ===
      'true'
    ) {
      return;
    }

    form.dataset.pawsanCheckedInitialized =
      'true';

    form.addEventListener(
      'change',
      function (event) {
        if (
          !event.target.matches(
            '.custlo-t1-form-check-input'
          )
        ) {
          return;
        }

        const group =
          event.target.closest(
            '.custlo-t1-form-check-group'
          ) || form;

        refreshCheckedClass(group);
      }
    );
  }

  function setupValidation(form) {
    if (
      form.dataset.pawsanValidationInitialized ===
      'true'
    ) {
      return;
    }

    form.dataset.pawsanValidationInitialized =
      'true';

    form.addEventListener(
      'submit',
      function (event) {
        const breedSelect =
          form.querySelector(
            '#pawsan-rasse-select'
          );

        if (
          breedSelect &&
          !breedSelect.value
        ) {
          event.preventDefault();

          breedSelect.classList.add(
            'pawsan-field-error'
          );

          breedSelect.focus();

          return;
        }

        const healthGroup =
          findGroupByLabel(
            form,
            FIELD_LABELS.health
          );

        const hasHealthChecked =
          healthGroup
            ? Array.from(
                healthGroup.querySelectorAll(
                  'input[type="checkbox"]'
                )
              ).some(function (input) {
                return input.checked;
              })
            : true;

        if (
          !hasHealthChecked &&
          healthGroup
        ) {
          event.preventDefault();

          healthGroup.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    );
  }

  function initPawsanForm() {
    const form = document.querySelector(
      '#custlo-t1-edit-form'
    );

    if (!form) return false;

    if (!hasEssentialFields(form)) {
      return false;
    }

    form.dataset.pawsanInitialized =
      'true';

    form.dataset.pawsanLanguage =
      CURRENT_LANGUAGE;

    hideAccountFields(form);

    setupTitle(form);

    setupUpload(form);

    setupDogName(form);

    setupGenderGroup(form);

    setupBirthday(form);

    setupAdoptedCheckbox(form);

    setupBreedDropdown(form);

    setupUnitField(
      form,
      'weight',
      'weightPlaceholder',
      'kg'
    );

    setupUnitField(
      form,
      'height',
      'heightPlaceholder',
      'cm'
    );

    setupHealthGroup(form);

    setupActivityGroup(form);

    setupStaturGroup(form);

    setupButtons(form);

    setupCheckedClass(form);

    setupValidation(form);

    return true;
  }

  function startPawsanFormInit() {
    let tries = 0;

    const maxTries = 40;

    const timer = window.setInterval(
      function () {
        tries += 1;

        const initialized =
          initPawsanForm();

        if (
          initialized ||
          tries >= maxTries
        ) {
          window.clearInterval(timer);
        }
      },
      250
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startPawsanFormInit
    );
  } else {
    startPawsanFormInit();
  }
})();